<div id="loader" [class.hidden]="isHidden" role="status" aria-live="polite" aria-label="Loading">
  <div class="loader-shell">
    <div class="loader-orbit" aria-hidden="true"></div>
    <div class="loader-spark" aria-hidden="true"></div>
    <div class="loader-label">
      <span class="loader-title">VNR</span>
      <span class="loader-subtitle">{{ 'loader.loading' | translate }}</span>
    </div>
  </div>
</div>

